import { Dices, MessageCircleQuestion, Trophy, Check } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import Reveal from "@/components/Reveal";

const STEPS = [
  { icon: Dices, title: "Lancez le dé", text: "Avancez case par case à travers les lieux emblématiques de Nice, du Vieux-Nice à l'Allianz Riviera." },
  { icon: MessageCircleQuestion, title: "Répondez aux questions", text: "Ville, football, Aiglons. Bonne réponse : vous gagnez une pièce de votre panoplie de supporter." },
  { icon: Trophy, title: "Atteignez le stade", text: "Le premier joueur à rassembler sa panoplie et à entrer dans l'Allianz Riviera est le 12e Homme. Et vous ?" },
];

const CONTENTS = [
  "1 plateau de jeu grand format illustré à la main",
  "6 pions en forme de ballon",
  "24 cartes Équipement supporter (maillot, écharpe, drapeau, ticket)",
  "500 questions sur cartes numérotées",
  "Accès à l'app Douzième Homme — +1000 questions bonus",
  "1 règle du jeu illustrée",
  "1 dé",
];

const PHOTOS = [
  { src: "/api/uploads/produit-plateau.png", alt: "Plateau de jeu Douzième Homme en situation" },
  { src: "/api/uploads/produit-kit-jeu.png", alt: "Kit de jeu avec grille de panoplie" },
  { src: "/api/uploads/produit-pions.png", alt: "Pions colorés en forme de ballon et dé" },
];

export default function Gameplay() {
  return (
    <section data-testid="gameplay-section" className="py-16 sm:py-24 lg:py-32 bg-onyx text-cream">
      <div className="container-x">
        <Reveal className="mb-14 sm:mb-20">
          <p className="eyebrow mb-4 !text-rouge-light">Comment on joue</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight uppercase leading-[1.1]">
            3 étapes, 45 minutes, des souvenirs.
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-20 sm:mb-28" data-testid="how-it-works">
          {STEPS.map(({ icon: Icon, title, text }, i) => (
            <Reveal key={title} delay={i * 0.1}>
              <div className="relative h-full border border-cream/15 p-8 hover:border-rouge-light/60 transition-colors">
                <span className="font-display text-6xl font-extrabold text-rouge-light/25 absolute top-5 right-6">{i + 1}</span>
                <Icon className="w-7 h-7 text-rouge-light mb-5" />
                <h3 className="font-display text-xl sm:text-2xl font-bold tracking-tight mb-3">{title}</h3>
                <p className="text-sm leading-relaxed text-cream/65">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <Reveal className="lg:col-span-5">
            <p className="eyebrow mb-4 !text-rouge-light">Contenu de la boîte</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight uppercase leading-[1.1] mb-8">
              Tout ce que vous recevez.
            </h2>
            <ul className="space-y-4" data-testid="box-contents-list">
              {CONTENTS.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm sm:text-base text-cream/80">
                  <Check className="w-5 h-5 text-rouge-light shrink-0 mt-0.5" /> {item}
                </li>
              ))}
            </ul>
          </Reveal>
          <div className="lg:col-span-7 grid grid-cols-2 gap-4">
            {PHOTOS.map((photo, i) => (
              <Reveal key={photo.src} delay={i * 0.1} className={i === 0 ? "col-span-2" : ""}>
                <img src={mediaUrl(photo.src)} alt={photo.alt} loading="lazy"
                  className="w-full bg-white border border-cream/10 p-4" />
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
